module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-info.bf799e7b.svg";